import { FC } from 'react';

type Props = {
	className?: string;
};

const DollarCircleIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M18.0002 10.0001C18.0002 14.4184 14.4184 18.0002 10.0001 18.0002C5.58176 18.0002 2 14.4184 2 10.0001C2 5.58176 5.58176 2 10.0001 2C14.4184 2 18.0002 5.58176 18.0002 10.0001Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M12.1682 8.449C12.0889 7.83887 11.3884 6.85308 10.1287 6.85306C8.66497 6.85303 8.04909 7.66368 7.92412 8.069C7.72916 8.61116 7.76815 9.72581 9.48378 9.84733C11.6284 9.99934 12.4875 10.2525 12.3782 11.565C12.2688 12.8774 11.0734 13.161 10.1287 13.1305C9.18385 13.1002 7.63811 12.6662 7.57812 11.4988M9.97874 5.99854V6.85596M9.97874 13.1226V13.9986'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default DollarCircleIcon;
